var $6cf33cd4c010a2fb$exports = {};
$6cf33cd4c010a2fb$exports = {
  "Empty": `Tuk\u{161}s`
};
export { $6cf33cd4c010a2fb$exports as default };